import React, { FC, ReactElement, useState } from 'react'
import { Input, Button, Checkbox, Typography, Row, Col, Form } from 'antd'
import { SignerFormItemProps } from './types'
import InputMask from 'react-input-mask'
import { MASKS } from 'constants/MASKS'
import { formValidatorForPhone } from 'utils/validatePhone'
import { validateSignerEmailUniqueness } from '../utils'

export const SignerFormItem: FC<SignerFormItemProps> = ({
  field,
  index,
  remove,
  showRemove,
  emailRequired = false,
  cellPhoneRequired = false
}): ReactElement => {
  const form = Form.useFormInstance()
  const initialAdditionalPhoneValue = form.getFieldValue(['signers', field.name, 'additionalPhone'])
  const [showAdditionalPhone, setShowAdditionalPhone] = useState(!!initialAdditionalPhoneValue)
  const shouldShowCheckbox = index < 2

  const handleAddPhoneNumber = () => {
    setShowAdditionalPhone(true)
  }

  return (
    <div className="signer-form-item">
      {showRemove && (
        <Row>
          <Col span={24} style={{ textAlign: 'right' }}>
            <Button type="link" onClick={() => remove(index)} className="remove-signer-button">
              remove
            </Button>
          </Col>
        </Row>
      )}
      <Row gutter={16}>
        <Col span={12}>
          <Form.Item
            {...field}
            name={[field.name, 'firstName']}
            rules={[{ required: true, message: 'First name is required' }]}
          >
            <Input placeholder="First Name" className="signer-input" />
          </Form.Item>
        </Col>
        <Col span={12}>
          <Form.Item
            {...field}
            name={[field.name, 'lastName']}
            rules={[{ required: true, message: 'Last name is required' }]}
          >
            <Input placeholder="Last Name" className="signer-input" />
          </Form.Item>
        </Col>
      </Row>
      <Row>
        <Col span={24}>
          <Form.Item
            {...field}
            name={[field.name, 'cellPhone']}
            rules={[
              { validator: formValidatorForPhone },
              { required: cellPhoneRequired, message: 'Cell phone is required for RON signing.' }
            ]}
          >
            <InputMask mask={MASKS.PHONE}>
              {(inputProps: any) => <Input {...inputProps} placeholder="Cell phone" className="signer-input" />}
            </InputMask>
          </Form.Item>
        </Col>
      </Row>
      {showAdditionalPhone && (
        <Row>
          <Col span={24}>
            <Form.Item {...field} name={[field.name, 'additionalPhone']} rules={[{ validator: formValidatorForPhone }]}>
              <InputMask mask={MASKS.PHONE}>
                {(inputProps: any) => (
                  <Input {...inputProps} placeholder="Additional phone" className="signer-input additional-phone" />
                )}
              </InputMask>
            </Form.Item>
          </Col>
        </Row>
      )}
      {!showAdditionalPhone && (
        <Row>
          <Col span={24}>
            <Button type="link" onClick={handleAddPhoneNumber} className="add-phone-button">
              + Add phone number
            </Button>
          </Col>
        </Row>
      )}
      <Row>
        <Col span={24}>
          <Form.Item
            {...field}
            name={[field.name, 'email']}
            rules={[
              { type: 'email', message: 'Please enter a valid email' },
              { required: emailRequired, message: 'Email address is required for RON signing.' },
              validateSignerEmailUniqueness(field.name)
            ]}
          >
            <Input placeholder="Email address" className="signer-input" />
          </Form.Item>
        </Col>
      </Row>
      {shouldShowCheckbox && (
        <Row>
          <Col span={24}>
            <Form.Item {...field} name={[field.name, 'allowAccessToOrder']} valuePropName="checked">
              <Checkbox className="confirmation-checkbox">
                Send a confirmation and provide basic access to order details via Snapdocs.
              </Checkbox>
            </Form.Item>
          </Col>
        </Row>
      )}
      {!shouldShowCheckbox && (
        <Row>
          <Col span={24}>
            <Typography.Text type="secondary" className="confirmation-checkbox">
              {"This person won't receive a confirmation or Snapdocs access."}
            </Typography.Text>
          </Col>
        </Row>
      )}
    </div>
  )
}

export default SignerFormItem
